<template>
  <div class="container py-5">
    <h2>{{ courseDetail.name }}</h2>
    <div class="card mt-3 border-0 overflow-hidden">
      <div class="bg-center" style="max-height: 300px; min-height: 300px"
        :style="{'background-image': 'url(' +
          checkAvatar(courseDetail.avatar_type, courseDetail.avatar_location) + ')' }"></div>
      <div class="card-body bg-light d-flex flex-md-row flex-column
        justify-content-between align-items-center">
        <div class="d-md-flex align-items-center d-none">
          <span class="text-primary text-nowrap mr-2" v-show="!isLoading">
            {{ completedPercent }} %
          </span>
          <progress v-show="!isLoading" class="course-progress"
            style="top: 100%; cursor: pointer;" :value="completedPercent" max="100"></progress>
        </div>
        <a @click.prevent="gaTrackLink('Course','Click Continue Button', '',
            '/course/' + coursePathVar + '/chapter/' +
            continueCourse.chapterID + '/post/' + continueCourse.path_var)"
          href="#" class="btn btn-primary px-5 btn-md-down-block"
          v-if="havenStartedCourse && firstCourse">
          <span v-show="!isLoading">繼續上課</span>
          <span v-show="!isLoading" class="material-icons align-bottom"> arrow_forward</span>
        </a>
        <a @click.prevent="gaTrackLink('Course', 'Click Start Button', '',
            '/course/' + coursePathVar + '/chapter/'
            + firstCourse.chapterID + '/post/' + firstCourse.path_var)"
          href="#" class="btn btn-primary px-5 btn-md-down-block" v-else-if="firstCourse">
          <span v-show="!isLoading">開始上課</span>
          <span v-show="!isLoading" class="material-icons align-bottom"> arrow_forward</span>
        </a>
      </div>
    </div>
    <div class="position-relative">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <h4 class="my-5">單元</h4>
      <!-- 搜尋區塊 -->
      <div class="row align-items-start mb-4">
        <div class="col-md-3 col-6">
          <div class="form-group">
            <select class="form-control" id="categoryFilter"
              v-model="categorySelected"
              @change="gaTrackEvent('Course', 'Filter - Category', categorySelected)">
              <option value="all">分類 - 全部</option>
              <option :value="chapter.name"
                v-for="chapter in checkItemActive(chapterList.chapters)" :key="chapter.id">
                {{ chapter.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="form-group">
            <select class="form-control" id="sort"
              v-model="sortSelected"
              @change="gaTrackEvent('Course', 'Filter - Sorting', sortSelected)">
              <option value="new">由新到舊</option>
              <option value="pass">由舊到新</option>
              <option value="reply_count">留言數最多</option>
              <option value="view_count">瀏覽數最多</option>
            </select>
          </div>
        </div>
        <div class="col-md-5 ml-auto">
          <div class="input-group position-relative bg-white" style="z-index: 3;">
            <input type="text" class="form-control border-right-0"
            placeholder="搜尋" aria-label="搜尋" aria-describedby="search"
            v-model="searchText" @keypress.enter="search(searchText)">
            <div class="input-group-append">
              <button class="btn btn-outline-light" type="button"
                id="search" @click="search(searchText)">
                <span class="material-icons align-bottom text-dark"> search </span>
              </button>
            </div>
          </div>
          <div class="list-group border-top-0 position-absolute rounded-0"
            v-show="searchIsOpen"
            style="z-index: 2; left: 15px; right: 15px; top: calc(100% - 2px);">
            <a href="#" class="list-group-item list-group-item-action"
              v-for="post in searchPosts" :key="post.id"
              @click.prevent="setResult(post.name)">{{ post.name }}</a>
          </div>
        </div>
      </div>
      <!-- -->
      <div class="list-group">
        <div v-if="searchResults.length > 0">
          <p>找到 {{ checkSearchResults.length }} 筆符合的單元</p>
          <post-in-course-list v-for="post in checkSearchResults" :key="post.data.id"
            :data="post.data" :url="post.redirectUrl"
            :post-status="checkLectureStatus(post.data.id)"
            :tag="post.data.chapter.name">
          </post-in-course-list>
        </div>
        <div v-else>
          <post-in-course-list
            v-for="post in sortAllPosts.slice(0, pageInfo.perPage * pageInfo.nowPage)"
            :key="post.id" :data="post" :url="'/course/' + coursePathVar + '/chapter/'
              + post.chapterID + '/post/' + post.path_var"
            :tag="post.chapterName"
            :post-status="checkLectureStatus(post.id)">
          </post-in-course-list>
          <frontend-pagination btn-text="更多單元"
            :post-data-length="sortAllPosts.length"
            @per-page="perPageData" @more-page="morePageData">
          </frontend-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    courseId: String,
    coursePathVar: String,
    courseData: String,
    awsBucket: String,
  },
  data() {
    return {
      courseDetail: JSON.parse(this.courseData),
      sortSelected: 'new',
      categorySelected: 'all',
      chapterList: [],
      coursesOptions: [],
      isLoading: false,
      allPosts: [],
      searchText: '', // 搜尋
      searchResults: [], // 搜尋結果
      searchIsOpen: false,
      pageInfo: {
        perPage: 0,
        nowPage: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    perPageData(val) {
      this.pageInfo.perPage = val;
    },
    morePageData(val) {
      this.pageInfo.nowPage = val;
    },
    getChapter() {
      const vm = this;
      vm.isLoading = true;
      axios.get(`/api/course/${vm.coursePathVar}`).then((res) => {
        vm.chapterList = res.data.data;
        vm.isLoading = false;
      });
    },
    getOptions() {
      const vm = this;
      axios.get(`/api/course/${vm.coursePathVar}/options`).then((res) => {
        vm.coursesOptions = res.data.data.options;
      });
    },
    filteredChapter(data) {
      const vm = this;
      if (vm.categorySelected == 'all') {
        return data;
      }
      return data.filter((post) => post.chapterName == vm.categorySelected);
    },
    checkLectureStatus(postID) {
      if (this.coursesOptions && this.coursesOptions.hasOwnProperty('completed')) {
        if (this.coursesOptions.completed.some((item) => item.post.id == postID)) {
          return 'check_circle';
        }
      }
      if (this.coursesOptions && this.coursesOptions.hasOwnProperty('read')) {
        if (this.coursesOptions.read.some((item) => item.post.id == postID)) {
          return 'timelapse';
        }
      }
      return 'radio_button_unchecked';
    },
    search(search) {
      const vm = this;
      if (search !== '') {
        vm.gaTrackEvent('Course', 'Search', '', search); // GA event
        axios.get(`/api/courses/search?content=${search}`).then((res) => {
          vm.searchResults = res.data.data;
          vm.searchIsOpen = false;
        }).catch((err) => {
          flash(`${err} 搜尋結果錯誤`, 'danger');
        });
      } else {
        vm.searchResults = [];
      }
    },
    setResult(text) {
      this.searchText = text;
      this.searchIsOpen = false;
    },
    checkAvatar(type, avatar) {
      if (type === 's3') {
        return `https://${this.awsBucket}.s3.amazonaws.com${avatar}`;
      }
      return avatar;
    },
  },
  watch: {
    searchText(val) {
      if (val !== '') {
        this.searchIsOpen = true;
      } else {
        this.searchIsOpen = false;
      }
    },
  },
  computed: {
    searchPosts() {
      const vm = this;
      return this.allPosts.filter((ele) => ele.name.indexOf(vm.searchText) !== -1);
    },
    checkSearchResults() {
      const vm = this;
      return this.searchResults.filter((post) => {
        const searchCourseHasData = post.data.chapter.course.hasOwnProperty('data') ? post.data.chapter.course.data.id : post.data.chapter.course.id;
        const redirectUrl = post.data.chapter.course.hasOwnProperty('data') ? `/course/${post.data.chapter.course.data.path_var}/chapter/${post.data.chapter.path_var}/post/${post.data.path_var}` : `/course/${post.data.chapter.course.path_var}/chapter/${post.data.chapter.path_var}/post/${post.data.path_var}`;
        vm.$set(post, 'redirectUrl', redirectUrl);
        return post.data.active && searchCourseHasData == vm.courseId;
      });
    },
    completedPercent() { // 計算課程完成率
      const vm = this;
      vm.allPosts = [];
      if (this.chapterList.chapters && this.chapterList.chapters.length > 0) {
        vm.checkItemActive(this.chapterList.chapters).forEach(
          (chapter) => vm.checkItemActive(chapter.posts).forEach((post) => vm.allPosts.push({
            ...post,
            chapterID: chapter.path_var,
            chapterId: chapter.id,
            chapterName: chapter.name,
          })),
        );
        if (this.coursesOptions.completed && this.coursesOptions.completed.length > 0) {
          const uniqCompleted = this.coursesOptions.completed.filter(
            (v, i, a) => a.findIndex((p) => (p.post.id === v.post.id)) === i,
          );
          const checkPostNotDelete = [];
          uniqCompleted.forEach((post) => {
            if (vm.allPosts.some((allpost) => allpost.id == post.post.id)) {
              checkPostNotDelete.push(post);
            }
          });
          return parseInt(checkPostNotDelete.length / vm.allPosts.length * 100);
        }
        return 0;
      }
      return 0;
    },
    havenStartedCourse() { // 有開始過課程嗎？
      if (this.coursesOptions.read && this.coursesOptions.read.length > 0) {
        return true;
      }
      return false;
    },
    firstCourse() { // 開始上課的課程: 發布時間最早的第一個 post
      const vm = this;
      if (!vm.havenStartedCourse) {
        if (vm.allPosts.length > 0) {
          const sortData = vm.checkItemActive(vm.allPosts).sort(
            (a, b) => a.opened_at.timestamp - b.opened_at.timestamp,
          );
          return sortData[0];
        }
      }
      return {};
    },
    continueCourse() { // 繼續上課的課程
      const vm = this;
      if (vm.havenStartedCourse) {
        if (vm.allPosts.length > 0) {
          const sortData = vm.checkItemActive(vm.allPosts).sort(
            (a, b) => a.opened_at.timestamp - b.opened_at.timestamp,
          );
          if (vm.coursesOptions.completed.length > 0) {
            // 篩出完成的 active post
            const filterActive = vm.coursesOptions.completed.filter((a) => a.post.active);
            // 找到最近一則完成
            const findLastest = filterActive.map(
              (e) => e.completed_at.timestamp,
            ).sort().reverse()[0];
            // 比對出最近一則完成的 post
            const mostRecentObject = filterActive.filter(
              (e) => e.completed_at.timestamp === findLastest,
            )[0];
            // 在以『發布時間』排序的 post 中找到下一則發布的資料
            const theNextOne = sortData.findIndex((e) => e.id === mostRecentObject.post.id);
            // 如果是最新一個發布，就回到第一個。如果不是，就找下一個
            if (theNextOne !== sortData.length - 1) {
              return sortData[theNextOne + 1];
            }
            return sortData[0];
          }
          return sortData[0];
        }
      }
      return {};
    },
    sortAllPosts() {
      const vm = this;
      const activeData = vm.checkItemActive(vm.allPosts);
      if (vm.sortSelected === 'new') { // 新到舊
        return vm.filteredChapter(activeData).sort(
          (a, b) => b.opened_at.timestamp - a.opened_at.timestamp,
        );
      } if (vm.sortSelected === 'pass') { // 舊到新
        return vm.filteredChapter(activeData).sort(
          (a, b) => a.opened_at.timestamp - b.opened_at.timestamp,
        );
      }
      return vm.filteredChapter(activeData).sort((a, b) => b[vm.sortSelected] - a[vm.sortSelected]);
    },
  },
  mounted() {
    this.getChapter();
    this.getOptions();
  },
};
</script>
<style scoped>
.bg-center {
  background-position: center center;
  background-repeat: no-repeat;
  background-size:cover
}
</style>
